
import { Component, Inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle
} from '@angular/material/dialog';
import { MatError, MatFormField, MatLabel } from "@angular/material/form-field";
import { MatInput } from "@angular/material/input";
import { CredentialTypes } from '@fry-it/risr-core';
import { AuthService } from '@fry-it/risr-core';


@Component({
    selector: 'app-edit-username-credential-dialog',
    templateUrl: './update-credential-username-dialog.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
    MatDialogContent,
    MatFormField,
    MatDialogActions,
    ReactiveFormsModule,
    MatInput,
    MatLabel,
    MatError,
    MatDialogTitle
]
})
export class UpdateCredentialUsernameDialogComponent implements OnInit {
  editUsernameForm: FormGroup;
  currentCredentialUsername: string;
  dialogTitle: string;
  label: string;

  integrations = { org_fry: { autoGenerateUsername: true, autoGeneratePassword: false } };
  orgHasintegration = false;

  constructor(
    private authService: AuthService,
    private fb: FormBuilder,
    private dialogRef: MatDialogRef<UpdateCredentialUsernameDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { currentCredentialUsername: string, credentialType: CredentialTypes }
  ) {
    this.currentCredentialUsername = data.currentCredentialUsername;
    if (data.credentialType === CredentialTypes.LOCAL) {
      this.dialogTitle = 'Edit local credential\'s username';
      this.label = 'New Local Username';
    } else if (data.credentialType === CredentialTypes.PROXY) {
      this.dialogTitle = 'Edit SSO credential\'s ID';
      this.label = 'New SSO ID';
      const org = this.authService.currentOrganisation();

      this.orgHasintegration = !!org && this.integrations[org];
    }
  }

  ngOnInit(): void {
    this.editUsernameForm = this.fb.group({
      useIntegration: [],
      newUsername: [this.currentCredentialUsername, Validators.required]
    });
  }

  onSubmit() {
    if (this.editUsernameForm.valid) {
      this.dialogRef.close(this.editUsernameForm.value);
    }
  }

  onCancel() {
    this.dialogRef.close(null);
  }
}
